import useMutationApi from 'src/api/useMutationApi';

export interface EnableModuleData {
  entityType: string;
  entityId: string;
  moduleName: string;
}

export interface EnableModuleResponse {
  success: boolean;
  message: string;
}

const useEnableModule = (onSuccess?: () => void) => {
  return useMutationApi<EnableModuleData, EnableModuleResponse>({
    endpoint: 'core/modules/enable',
    method: 'POST',
    successMessage: 'Module enabled successfully',
    errorMessage: 'Failed to enable module',
    options: {
      onSuccess,
    },
  });
};

export default useEnableModule;
